<template>
  <div>
    <router-view name="manageInteressadoRouter"/>
  </div>
</template>

<script>

export default {
  created () {
    this.$router.push({ name: 'consultaInteressados' })
  }
}
</script>
